import React from "react";
import MaimIslam2 from "./MaimIslam2/MaimIslam";
import HAboutIslam from "./HAboutIslam";
import AboutCardIslam from "../about/AboutCardIslam";
import Header from "../../components/common/header/Header";
import FooterIslam from "../common/footer/FooterIslam";

const Homes = () => {
  return (
    <>
{/* <Header/> */}
      <MaimIslam2  />
      <AboutCardIslam />
      <HAboutIslam />
        <FooterIslam/>
    </>
  );
};

export default Homes;
